import Api from '@/services/Api'

export default {
    login(params) {
        return Api().post(
            'auth/token/', {
                username: params.username,
                password: params.password,
            })
    },
    refreshToken() {
        Api().post(
            'auth/tokenrefresh/', {
                token: localStorage.getItem('token')
            }
        )
    },
    logout() {
        Api().post('auth/token/logout/', {
            token: localStorage.getItem('token')
        }).then(() => {
            localStorage.removeItem("token");
            window.location.reload();
        }).catch(() => {
            localStorage.removeItem("token");
            window.location.reload();
        });
    },
    verifyToken() {
        Api().post('auth/token/verify/', {
            token: localStorage.getItem('token')
        }).catch((error) => {
            if (error.response.status == 403) {
                this.logout();
            }
        })
    }
}